(function($) {
  'use strict';

  const fontSwitcher = {
    dom: function() {
      this.$wrapper = $('.font-switcher');
      this.$expand = $('[data-js-hook="font-switcher-expand"]');
      this.$button = $('[data-font-switcher]');

      this.filter = {
        form: $('#tabFilters'),
        checkbox: $('#freeFonts'),
        checkboxes: $('[data-font-type]'),
        sort: $('.tabbed__filter-radio[type="radio"]')
      }

      this.$fontGroups = $('[data-font-group]');
      this.direction = 'asc';

      this.$fonts = $('[data-font-filter]');
      this.$notFree = $('[data-font-filter]:not([data-font-filter="free"])');
    },

    dropdown: function() {
      const _ = this;

      this.$expand.on('click', function() {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
          $(this).parent().addClass('expanded');
        }
        else {
          $(this).parent().removeClass('expanded');
        }
      });

      $(document).on('click', function(event) {
        if (!event.target.closest('.font-switcher__select-wrap')) {
          _.$expand.removeClass('active').parent().removeClass('expanded');
        }
      });

      $(document).keyup(function(e) {
        if (e.key === "Escape") {
          _.$expand.removeClass('active').parent().removeClass('expanded');
        }
      });
    },

    switch: function() {
      const _ = this;

      this.$button.on('click', function() {
        let $this = $(this);
        let type = $this.data('font-switcher');
        let family = $this.data('font-family');
        let $parent = $(this).closest('.font-switcher__select-wrap');
        _.$wrapper.css('--font-switcher-' + type, family);
        $parent.removeClass('expanded');
        _.$expand.removeClass('active');
        $parent.children('.selected').children('[data-font-switcher="content"]').html($(this).html());
      });
    },

    filters: function() {
      const _ = this;

      this.filter.checkboxes.on('change', (element) => {
        _.filter.form.submit();
      });

      this.filter.checkbox.on('change', function() {
        _.filter.form.submit();
      });

      this.filter.sort.on('change', function() {
        _.filter.form.submit();
      });

      this.filter.form.on('submit', function(event) {
        event.preventDefault();
        const $this = $(this);
        let filters = $this.serializeArray();
        const type = filters.find(e => e.name == 'font_type').value;

        switch(type) {
          case 'all':
            _.$fonts.show();
            break;
          case 'free':
            $('[data-font-switcher="headline"][data-font="' + jcms.font_defaults.headline + '"]').click();
            $('[data-font-switcher="body"][data-font="' + jcms.font_defaults.body + '"]').click();
            _.$fonts.filter('[data-font-filter="' + type + '"]').show();
            _.$fonts.not('[data-font-filter="' + type + '"]').hide();
            break;
          case 'extended':
            $('[data-font-switcher="headline"][data-font-filter="extended"]').get($('[data-font-switcher="headline"][data-font-filter="extended"]').length - 1).click();
            $('[data-font-switcher="body"][data-font-filter="extended"]').get(0).click();
            _.$fonts.filter('[data-font-filter="' + type + '"]').show();
            _.$fonts.not('[data-font-filter="' + type + '"]').hide();
            break;
          default:
            _.$fonts.filter('[data-font-filter="' + type + '"]').show();
            _.$fonts.not('[data-font-filter="' + type + '"]').hide();
            break;
        }

        for (let i in filters) {
          let filter = filters[i];
          if (filter.name === 'sort') {
            if (filter.value !== _.direction) {
              _.$fontGroups.each(function() {
                let $group = $(this);
                let alphabeticallyOrderedDivs = $group.find('[data-font]').sort(function(a, b) {
                  return $(a).data('font').toLowerCase().localeCompare($(a).data('font').toLowerCase());
                }).toArray().reverse();

                $group.empty().append(alphabeticallyOrderedDivs);
              });
              _.direction = filter.value;
            }
          }
        }
      });
    },

    ready: function() {
      this.dom();
      this.dropdown();
      this.switch();
      this.filters();
    }
  };

  $(function() { fontSwitcher.ready(); });

})(jQuery);
